import { MutableRefObject } from 'react';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface LinkSearchStore {
    query: string;
    setQuery: (query: string) => void;

    searchRef: MutableRefObject<HTMLInputElement | null>;
    listRef: MutableRefObject<HTMLDivElement | null>;

    isTypesensePending: boolean;
    setIsTypesensePending: (isPending: boolean) => void;
    clear: () => void;
}

const useLinkSearchStore = create<LinkSearchStore>(set => ({
    query: '',
    setQuery: query => set({ query }),

    searchRef: { current: null },
    listRef: { current: null },

    isTypesensePending: false,
    setIsTypesensePending: isTypesensePending => set({ isTypesensePending }),
    clear: () => set({ query: '' }),
}));

export { useLinkSearchStore };
export type { LinkSearchStore };
